module.exports = __webpack_public_path__ + "img/02-800x800.2784d5bc.jpg";